import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { CookieService } from 'ngx-cookie-service';
import { addressbook } from './addressbook/addressbook.lazy';
import { AppComponent } from './app.component';
import { CreditCardsComponents, CreditCardsModule } from './credit-cards/credit-cards.module';
import { DashboardComponents, DashboardModule } from './dashboard/dashboard.module';
import { DialogsComponents, DialogsModule } from './dialogs/dialogs.module';
import { JssContextService } from './jss-context.service';
import { JssDataFetcherService } from './jss-data-fetcher.service';
import { GraphQLModule } from './jss-graphql.module';
import { JssMetaService } from './jss-meta.service';
import { JssLayoutService } from './layout/jss-layout.service';
import { LayoutComponents, LayoutModule } from './layout/layout.module';
import { LoginComponents, LoginModule } from './login/login.module';
import { SentooComponents, SentooModule } from './sentoo/sentoo.module';
import { miscellaneous } from './miscellaneous/miscellaneous.lazy';
import { orcoAddressbook } from './orco/orco-addressbook/orco-addressbook.lazy';
import { orcoLayout } from './orco/orco-layout/orco-layout.lazy';
import { orcoLogin } from './orco/orco-login/orco-login.lazy';
import { orcoMiscellaneous } from './orco/orco-miscellaneous/orco-miscellaneous.lazy';
import { orcoPersonalArchive } from './orco/orco-personal-archive/orco-personal-archive.lazy';
import { orcoTransfers } from './orco/orco-transfers/orco-transfers.lazy';
import { overdraft } from './overdraft/overdraft.lazy';
import { personalArchive } from './personal-archive/personal-archive.lazy';
import { PublicComponents, PublicModule } from './public/public.module';
import { ReportingComponents, ReportingModule } from './reporting/reporting.module';
import { RoutingComponents, RoutingModule } from './routing/routing.module';
import { SessionComponents, SessionModule } from './session/session.module';
import { SharedComponents, SharedModule } from './shared/shared.module';
import { transactions } from './transactions/transactions.lazy';
import { transfers } from './transfers/transfers.lazy';
import { userAccessManagement } from './user-access-management/user-access-management.lazy';


const ImportedModules = [
  ...RoutingComponents,
  ...SharedComponents,
  ...LayoutComponents,
  ...LoginComponents,
  ...SentooComponents,
  ...PublicComponents,
  ...DashboardComponents,
  ...SessionComponents,
  ...ReportingComponents,
  ...DialogsComponents,
  ...CreditCardsComponents
];

const JssComponentsLazyLoading = [
  ...transactions,
  ...userAccessManagement,
  ...transfers,
  ...addressbook,
  ...miscellaneous,
  ...personalArchive,
  ...orcoTransfers,
  ...orcoMiscellaneous,
  ...overdraft,
  ...orcoLayout,
  ...orcoPersonalArchive,
  ...orcoAddressbook,
  ...orcoLogin
];

@NgModule({
  imports: [
   // withServerTransition is needed to enable universal rendering
   BrowserModule.withServerTransition({ appId: 'my-app' }),
   BrowserTransferStateModule,
   HttpClientModule,
   SharedModule,
   RoutingModule,
   BrowserAnimationsModule,
   TranslateModule.forRoot(),
   LayoutModule,
   GraphQLModule,
   SentooModule,
   LoginModule,
   PublicModule,
   CreditCardsModule,
   DashboardModule,
   SessionModule,
   DialogsModule,
   ReportingModule,
   // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
   JssModule.withComponents(ImportedModules, <any>JssComponentsLazyLoading)
  ],
  providers: [
    JssContextService,
    JssDataFetcherService,
    JssLayoutService,
    JssMetaService,
    CookieService,
    // IMPORTANT: you must set the base href with this token, not a <base> tag in the HTML.
    // the Sitecore Experience Editor will not work correctly when a base tag is used.
    { provide: APP_BASE_HREF, useValue: '/' },
  ],
  declarations: [
    AppComponent
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
